import React, { useState } from "react";
import {
	Container,
	Row,
	Col,
	Form,
	Button,
	Alert,
	Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../../pages/password-reset/passAction";

const initialState = {
	otp: "",
	password: "",
	confirmPass: "",
};

const passVerificationError = {
	isLenthy: false,
	hasUpper: false,
	hasLower: false,
	hasNumber: false,
	hasSpclChr: false,
	confirmPass: false,
};
export const UpdatePassComp = () => {
	const dispatch = useDispatch();
	const [newPassword, setNewPassword] = useState(initialState);
	const [passwordError, setPasswordError] = useState(passVerificationError);
	const [show, setShow] = useState(false);
	const [confirmShow, setconfirmShow] = useState(false);

	const { isLoading, status, message, email } = useSelector(
		state => state.password
	);

	const handleOnChange = e => {
		const { name, value } = e.target;

		setNewPassword({ ...newPassword, [name]: value });

		if (name === "password") {
			const isLenthy = value.length > 8;
			const hasUpper = /[A-Z]/.test(value);
			const hasLower = /[a-z]/.test(value);
			const hasNumber = /[0-9]/.test(value);
			const hasSpclChr = /[@,#,$,%,&]/.test(value);

			setPasswordError({
				...passwordError,
				isLenthy,
				hasUpper,
				hasLower,
				hasNumber,
				hasSpclChr,
			});
		}

		if (name === "confirmPass") {
			setPasswordError({
				...passwordError,
				confirmPass: newPassword.password === value,
			});
		}
	};

	const handleOnSubmit = e => {
		e.preventDefault();

		const { otp, password } = newPassword;

		const newPassObj = {
			otp,
			newPassword: password,
			email,
		};
		dispatch(updatePassword(newPassObj));
	};

	return (
		<Container>
			<Row>
				<Col>
					<h1 className="text-info">Update Password</h1>
				</Col>
			</Row>
			<Row>
				<Col>
					{message && (
						<Alert variant={status === "success" ? "success" : "danger"}>
							{message}
						</Alert>
					)}
					{isLoading && <Spinner variant="primary" animation="border" />}
				</Col>
			</Row>
			<Row>
				<Col>
					<Form onSubmit={handleOnSubmit}>
						<Form.Group
							style={{
								alignItems: "center",

								display: "flex",
							}}
						>
							<Form.Label>OTP</Form.Label>
							<Form.Control
								type="number"
								name="otp"
								value={newPassword.otp}
								onChange={handleOnChange}
								placeholder="OTP"
								required
								style={{ maxWidth: "1400px", margin: "0px 10px" }}
							/>
						</Form.Group>

						<Form.Group
							style={{
								alignItems: "center",

								display: "flex",
							}}
						>
							<Form.Label>New Password</Form.Label>
							<Form.Control
								type={show ? "text" : "password"}
								name="password"
								value={newPassword.password}
								onChange={handleOnChange}
								placeholder="Password"
								required
								style={{ maxWidth: "1400px", margin: "0px 10px" }}
							/>
							<button
								type="button"
								style={{
									cursor: "pointer",
									margin: "0 10px",
									border: "none",

									background: "none",
								}}
								onClick={() => {
									setShow(!show);
								}}
							>
								{show ? (
									<i className="far fa-eye" />
								) : (
									<i
										className="far fa-eye-slash"
										onClick={() => setShow(show)}
									/>
								)}
							</button>
						</Form.Group>

						<Form.Group
							style={{
								alignItems: "center",

								display: "flex",
							}}
						>
							<Form.Label>Confirm New Password</Form.Label>
							<Form.Control
								type={confirmShow ? "text" : "password"}
								name="confirmPass"
								value={newPassword.confirmPass}
								onChange={handleOnChange}
								placeholder="Confirm Password"
								required
								style={{ maxWidth: "1400px", margin: "0px 10px" }}
							/>
							<button
								type="button"
								style={{
									cursor: "pointer",
									margin: "0 10px",
									border: "none",

									background: "none",
								}}
								onClick={() => {
									setconfirmShow(!confirmShow);
								}}
							>
								{confirmShow ? (
									<i className="far fa-eye" />
								) : (
									<i
										className="far fa-eye-slash"
										onClick={() => setconfirmShow(confirmShow)}
									/>
								)}
							</button>
						</Form.Group>
						<Form.Text>
							{!passwordError.confirmPass && (
								<div className="text-danger mb-3">Password doesn't match!</div>
							)}
						</Form.Text>

						<ul className="mb-4">
							<li
								className={
									passwordError.isLenthy ? "text-success" : "text-danger"
								}
							>
								Min 8 characters
							</li>
							<li
								className={
									passwordError.hasUpper ? "text-success" : "text-danger"
								}
							>
								At least one upper case
							</li>
							<li
								className={
									passwordError.hasLower ? "text-success" : "text-danger"
								}
							>
								At least one lower case
							</li>
							<li
								className={
									passwordError.hasNumber ? "text-success" : "text-danger"
								}
							>
								At least one number
							</li>
							<li
								className={
									passwordError.hasSpclChr ? "text-success" : "text-danger"
								}
							>
								At least on of the special characters i.e @ # $ % &{" "}
							</li>
						</ul>

						<Button
							variant="primary"
							type="submit"
							disabled={Object.values(passwordError).includes(false)}
						>
							Submit
						</Button>
					</Form>
					<a
						href="/"
						style={{
							textDecoration: "none",
							color: "red",
							display: "flex",
							justifyContent: "end",
							alignItem: "center",
							marginBottom: 20,
						}}
					>
						Login Now
					</a>
				</Col>
			</Row>
		</Container>
	);
};
